/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_max_characters = /** @type {(inputs: { max: NonNullable<unknown> }) => string} */ (i) => {
	return `Maximální počet znaků : <b>${i.max}</b>`
};

const da_max_characters = /** @type {(inputs: { max: NonNullable<unknown> }) => string} */ (i) => {
	return `Maksimalt antal tegn: <b>${i.max}</b>`
};

const de_max_characters = /** @type {(inputs: { max: NonNullable<unknown> }) => string} */ (i) => {
	return `Maximale Zeichenanzahl: <b>${i.max}</b>`
};

const en_max_characters = /** @type {(inputs: { max: NonNullable<unknown> }) => string} */ (i) => {
	return `Maximum number of characters: <b>${i.max}</b>`
};

const es_max_characters = /** @type {(inputs: { max: NonNullable<unknown> }) => string} */ (i) => {
	return `Número máximo de caracteres: <b>${i.max}</b>`
};

const fr_max_characters = /** @type {(inputs: { max: NonNullable<unknown> }) => string} */ (i) => {
	return `Nombre maxi de caractères : <b>${i.max}</b>`
};

const hu_max_characters = /** @type {(inputs: { max: NonNullable<unknown> }) => string} */ (i) => {
	return `Maximális karakter szám : <b>${i.max}</b>`
};

const it_max_characters = /** @type {(inputs: { max: NonNullable<unknown> }) => string} */ (i) => {
	return `Numero massimo di caratteri: <b>${i.max}</b>`
};

const nl_max_characters = /** @type {(inputs: { max: NonNullable<unknown> }) => string} */ (i) => {
	return `Maximaal aantal tekens: <b>${i.max}</b>`
};

const pl_max_characters = /** @type {(inputs: { max: NonNullable<unknown> }) => string} */ (i) => {
	return `Maksymalna liczba znaków: <b>${i.max}</b>`
};

const pt_max_characters = /** @type {(inputs: { max: NonNullable<unknown> }) => string} */ (i) => {
	return `Número máximo de caracteres: <b>${i.max}</b>`
};

const sv_max_characters = /** @type {(inputs: { max: NonNullable<unknown> }) => string} */ (i) => {
	return `Max antal tecken: <b>${i.max}</b>`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ max: NonNullable<unknown> }} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const max_characters = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.max_characters(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("max_characters", locale)
	if (locale === "cs") return cs_max_characters(inputs)
	if (locale === "da") return da_max_characters(inputs)
	if (locale === "de") return de_max_characters(inputs)
	if (locale === "en") return en_max_characters(inputs)
	if (locale === "es") return es_max_characters(inputs)
	if (locale === "fr") return fr_max_characters(inputs)
	if (locale === "hu") return hu_max_characters(inputs)
	if (locale === "it") return it_max_characters(inputs)
	if (locale === "nl") return nl_max_characters(inputs)
	if (locale === "pl") return pl_max_characters(inputs)
	if (locale === "pt") return pt_max_characters(inputs)
	return sv_max_characters(inputs)
};